import { Helpers } from "../../helpers/helpers";
import {KEY_ESCAPE} from "../../constans";
import {ScrollDirectionEnum} from "../../types";

/**
 * Скрипты шапки
 */
export default class Header {
    private FIXED_CLASS = 'fixed';
    private OPEN_BURGER_MENU = 'burger-menu-open';
    private ACTIVE_ICON_CLASS = 'active';
    private OPEN_SEARCH_PANEL_CLASS = 'open-search-panel';
    private HAS_VALUE = 'has-value';
    private OPEN_CLASS = 'open';

    private readonly $holder: JQuery;
    private readonly $btnBurgerMenu: JQuery;
    private isSearchPanelOpen: boolean = false;
    private readonly $searchField: JQuery;
    private readonly $searchPanelWrapper: JQuery;
    private readonly $burgerMenu: JQuery;
    private readonly $burgerMenuWrapper: JQuery;

    private selectors = {
        btnBurgerMenu: '.js-burger-button',
        btnSearch: '.js-toggle-search',
        searchField: '.js-search-panel-field',
        searchPanelWrapper: '.js-search-panel-wrapper',
        btnClear: '.js-search-clear',
        burgerMenu: '.js-burger-menu',
        burgerMenuItem: '.js-burger-menu-item',
        burgerMenuWrapper: '.js-burger-menu-wrapper'
    };

    constructor($holder: JQuery) {
        this.$holder = $holder;
        this.$btnBurgerMenu = this.$holder.find(this.selectors.btnBurgerMenu);
        this.$searchField = this.$holder.find(this.selectors.searchField);
        this.$searchPanelWrapper = this.$holder.find(this.selectors.searchPanelWrapper);
        this.$burgerMenu = this.$holder.find(this.selectors.burgerMenu);
        this.$burgerMenuWrapper = this.$holder.find(this.selectors.burgerMenuWrapper);

        this.scrollHandler = this.scrollHandler.bind(this);
        this.openBurgerMenuHandler = this.openBurgerMenuHandler.bind(this);
        this.outsideSearchPanelHandler = this.outsideSearchPanelHandler.bind(this);
        this.escUpSearchPanelHandler = this.escUpSearchPanelHandler.bind(this);
        this.resetEventsSearchPanel = this.resetEventsSearchPanel.bind(this);

        this.init();
    }

    private init(): void
    {
        this.scrollHandler();
        $(window).on('scroll', this.scrollHandler);

        this.$btnBurgerMenu.on('click', this.openBurgerMenuHandler);

        this.$holder.on('click', this.selectors.btnSearch, () => {
            this.toggleSearchPanel();

            $(document).on('click', this.outsideSearchPanelHandler);
            $(document).on('keyup', this.escUpSearchPanelHandler);
        });
    }

    /**
     * Функция обработчик скрола
     * @private
     */
    private scrollHandler(): void
    {
        const headerContainerHeight = this.$holder.height();
        const scrollPosition = window.pageYOffset;

        scrollPosition >= headerContainerHeight ?
            this.$holder.addClass(this.FIXED_CLASS) :
            this.$holder.removeClass(this.FIXED_CLASS);
    }

    /**
     * Функция обработчик клика на бургер кнопку
     * @private
     */
    private openBurgerMenuHandler():void
    {
        const $burgerMenuItems = this.$holder.find(this.selectors.burgerMenuItem)
        if (this.$holder.hasClass(this.OPEN_BURGER_MENU)) {
            this.$holder.removeClass(this.OPEN_BURGER_MENU);
            this.$btnBurgerMenu.removeClass(this.ACTIVE_ICON_CLASS);
            this.$burgerMenu.removeClass(this.OPEN_CLASS);

            setTimeout(() => {
                $burgerMenuItems.removeClass('animated').css({'visibility' : 'hidden', 'animation-name':''});
            }, 300)

            Helpers.setOverflowHtml(false);
        }
        else {
            const height = window.innerHeight - 56 + 'px'
            this.$burgerMenuWrapper.css({'height': height})
            this.$holder.addClass(this.OPEN_BURGER_MENU);
            this.$btnBurgerMenu.addClass(this.ACTIVE_ICON_CLASS);
            this.$burgerMenu.addClass(this.OPEN_CLASS);

            $burgerMenuItems.map((index, element) => {
                setTimeout(() => {
                    $(element).addClass('animated').css({'visibility' : 'visible', 'animation-name':'fadeInUp'});
                }, index * 200)
            })

            Helpers.setOverflowHtml(true);
        }
    }

    /**
     * Переключатель состояния поисковой панели
     */
    private toggleSearchPanel(): void {

        this.isSearchPanelOpen = !this.isSearchPanelOpen;

        this.$holder.toggleClass(this.OPEN_SEARCH_PANEL_CLASS);

        if (!this.isSearchPanelOpen) {
            this.$searchPanelWrapper.removeClass(this.HAS_VALUE);
        }

        if (this.isSearchPanelOpen && typeof this.$searchField !== 'undefined') {
            this.$searchField.val('')
            this.$searchField.trigger('focus');
        }
    }

    /**
     * Обработчик клика вне панели поиска
     * @param evt
     */
    private outsideSearchPanelHandler(evt: JQuery.ClickEvent): void
    {
        const $target = $(evt.target);
        const $holder = $target.closest(this.selectors.searchPanelWrapper);
        const $toggleHolder = $target.closest(this.selectors.btnSearch);

        if ($holder.length || $toggleHolder.length) {
            return;
        }

        this.toggleSearchPanel();
        this.resetEventsSearchPanel();
    }

    /**
     * Обработчик клика на esc
     * @param evt
     */
    private escUpSearchPanelHandler(evt: JQuery.KeyUpEvent): void
    {
        if (evt.key !== KEY_ESCAPE) {
            return;
        }

        this.toggleSearchPanel();
        this.resetEventsSearchPanel();
    }

    /**
     * Сброс прослушивания событий
     * @private
     */
    private resetEventsSearchPanel(): void {
        $(document).off('click', this.outsideSearchPanelHandler);
        $(document).off('keyup', this.escUpSearchPanelHandler);
    }
}
